<div class="ai-loader-panel" [attr.data-paused]="false" *transloco="let t; currentLang as currentLang">
  <header class="panel-head">
    <div class="powered">
      <span>bdjobs</span>
      <span class="ai-word">Aí</span>
      <em>powered</em>
    </div>
    <h2>
      {{ t('matchingPercentageTitle') }}
      <span class="pro">PRO</span>
    </h2>
    <p class="panel-subtitle">{{ t('matchingPercentageDescription') }}</p>
  </header>

  <div class="loading-view" id="loading-view">
    <div class="hero">
      <div class="orb" aria-hidden="true">
        <div class="orb-ring r3"></div>
        <div class="orb-ring r1"></div>
        <div class="orb-ring r2"></div>
        <div class="orb-core">
          <svg width="29" height="29" viewBox="0 0 32 32" fill="none">
            <path d="M15 4 18.1 12.9 27 16l-8.9 3.1L15 28l-3.1-8.9L3 16l8.9-3.1L15 4Z"
                  stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
            <path d="m26 2 1.1 3.9L31 7l-3.9 1.1L26 12l-1.1-3.9L21 7l3.9-1.1L26 2Z"
                  fill="currentColor" opacity=".65"/>
          </svg>
        </div>
        <span class="sparkle-small">✧</span>
        <span class="sparkle-small second">✦</span>
      </div>

      <div class="stage-copy" [class.copy-enter]="animatingCopy()">
        <h3>
          <span>{{ currentStage.title }}</span>
          <span class="ellipsis" aria-hidden="true">...</span>
        </h3>
        <p class="hero-description">{{ currentStage.description }}</p>
      </div>
    </div>

    <div class="progress-block">
      <div class="progress-meta">
        <span>{{ currentStage.progress }}</span>
        <strong>
          {{ currentLang === 'bn' ? (progressPercent() | toBanglaNumber) : progressPercent() }}%
        </strong>
      </div>
      <div class="progress-track" role="progressbar" aria-label="AI assessment progress"
           aria-valuemin="0" aria-valuemax="100" [attr.aria-valuenow]="progressPercent()">
        <div class="progress-fill" [style.width.%]="progressPercent()"></div>
      </div>
    </div>

    <div class="checklist" aria-label="Assessment steps">
      @for (step of steps; track $index; let i = $index) {
        <div class="step"
             [class.done]="i < currentStage.step"
             [class.active]="i === currentStage.step">
          <span class="step-icon">
            <span class="step-number">{{ currentLang === 'bn' ? (step.icon | toBanglaNumber) : step.icon }}</span>
          </span>
          <span class="step-label">{{ currentLang === 'bn' ? step.labelBn : step.label }}</span>
          <span class="step-meta">
            {{ getStepStatusText(i, currentStage.step) }}
          </span>
        </div>
      }
    </div>

    <div class="loading-footer">
      <span class="live-indicator">
        <i></i>
        <span>{{ currentStage.footer }}</span>
      </span>
      <p>
        {{ currentLang === 'bn' ? 'আপনার প্রোফাইলের সাথে এই চাকরির মিল খতিয়ে দেখা হচ্ছে।' : 'We\'re looking at the details that make this opportunity a match for you.' }}
      </p>
    </div>
  </div>

  <span class="sr-only" role="status" aria-live="polite">
    {{ currentStage.title }}. {{ currentStage.description }}
  </span>
</div>

